import React, { useEffect, useRef, useState } from "react";
import api from "../setupAxios";

// PisoAutocomplete — campo de texto con desplegable de pisos "id - abreviatura"
// (se puede escribir el ID o la abreviatura; /buscar_piso busca por las dos).
// Al elegir uno, el texto queda como "id abreviatura" (el mismo formato que
// entienden las líneas de ruta) y se avisa con onSelect(piso).
//
// Es un input normal por lo demás: `value`/`onChange(texto)` controlados, y
// cualquier otra prop (ref vía inputRef, onKeyDown, onPaste, onBlur,
// className, placeholder...) se pasa tal cual al <input>. Con el desplegable
// abierto, ↑/↓ mueven la selección, Intro/Tab eligen y Esc lo cierra; si
// está cerrado, las teclas llegan al onKeyDown del padre sin tocar.
export const textoPiso = (p) => `${p.id_origen ?? p.id} ${p.codigo || ""}`.trim();

export default function PisoAutocomplete({ value, onChange, onSelect, inputRef, onKeyDown, onBlur, style, wrapStyle, ...rest }) {
  const [matches, setMatches] = useState([]);
  const [sel, setSel] = useState(0);
  const timer = useRef(null);
  const ultimaBusqueda = useRef("");

  useEffect(() => () => clearTimeout(timer.current), []);

  const buscar = (texto) => {
    clearTimeout(timer.current);
    const q = texto.trim();
    // Ya tiene el formato "id abreviatura" (elegido o pegado): no molestar.
    if (!q || /^\d+\s+\S/.test(q)) { setMatches([]); return; }
    timer.current = setTimeout(async () => {
      ultimaBusqueda.current = q;
      try {
        const { data } = await api.get("/buscar_piso", { params: { q } });
        if (ultimaBusqueda.current === q) { setMatches(data || []); setSel(0); }
      } catch { setMatches([]); }
    }, 200);
  };

  const elegir = (p) => {
    clearTimeout(timer.current);
    setMatches([]);
    onChange(textoPiso(p));
    onSelect?.(p);
  };

  const teclas = (e) => {
    if (matches.length) {
      if (e.key === "ArrowDown") { e.preventDefault(); setSel((s) => (s + 1) % matches.length); return; }
      if (e.key === "ArrowUp") { e.preventDefault(); setSel((s) => (s - 1 + matches.length) % matches.length); return; }
      if (e.key === "Enter" || e.key === "Tab") { e.preventDefault(); elegir(matches[sel] || matches[0]); return; }
      if (e.key === "Escape") { e.preventDefault(); setMatches([]); return; }
    }
    onKeyDown?.(e);
  };

  return (
    <div style={{ position: "relative", ...wrapStyle }}>
      <input
        {...rest}
        ref={inputRef}
        style={style}
        value={value}
        autoComplete="off"
        onChange={(e) => { onChange(e.target.value); buscar(e.target.value); }}
        onKeyDown={teclas}
        onBlur={(e) => { setTimeout(() => setMatches([]), 150); onBlur?.(e); }}
      />
      {matches.length > 0 && (
        <div className="deplist">
          {matches.map((p, i) => (
            <div key={p.id_origen ?? p.id} className={`do ${i === sel ? "sel" : ""}`}
                 onMouseEnter={() => setSel(i)}
                 onMouseDown={(e) => { e.preventDefault(); elegir(p); }}>
              <b className="mono">{p.id_origen ?? p.id}</b> <span className="muted">-</span> {p.codigo}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
